import { render, staticRenderFns } from "./Debug.vue?vue&type=template&id=06621579&scoped=true&"
import script from "./Debug.vue?vue&type=script&lang=ts&"
export * from "./Debug.vue?vue&type=script&lang=ts&"
import style0 from "./Debug.vue?vue&type=style&index=0&id=06621579&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06621579",
  null
  
)

export default component.exports